export enum Gender {
  MALE = 'M',
  FEMALE = 'F',
  KID = 'K',
  BOY = 'B',
  GIRL = 'G'
}
